import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL ?? '';

type DbStatus = 'loading' | 'not_configured' | 'disconnected' | 'connected';

export default function SetupNotice() {
  const [status, setStatus] = useState<DbStatus>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    async function check() {
      try {
        const res = await axios.get(`${API_URL}/health`);
        const db = res.data?.database as string;
        if (db === 'connected') {
          setStatus('connected');
          return;
        }
        setStatus(db === 'not_configured' ? 'not_configured' : 'disconnected');
        setMessage(res.data?.message || '');
      } catch {
        setStatus('disconnected');
        setMessage('API server is not running. In a terminal run: npm run dev:server');
      }
    }
    check();
  }, []);

  if (status === 'loading' || status === 'connected') return null;

  return (
    <div className="mb-6 p-4 rounded-lg border border-[#ffbf00]/30 bg-[rgba(255,191,0,0.08)] text-on-surface text-[13px] leading-relaxed">
      <div className="flex items-start gap-2">
        <span className="material-symbols-outlined text-[#ffbf00] text-[20px] flex-shrink-0">info</span>
        <div>
          <p className="font-bold text-[#ffbf00] mb-1">Backend setup required</p>
          {status === 'not_configured' ? (
            <>
              <p className="text-on-surface-variant mb-2">
                You have not added a database yet — that is normal. Registration will work after this
                one-time setup:
              </p>
              <ol className="list-decimal list-inside space-y-1 text-on-surface-variant font-mono text-[12px]">
                <li>Create a free database at neon.tech</li>
                <li>Copy the connection string into <strong className="text-on-surface">apps/server/.env</strong> as <code>DATABASE_URL</code></li>
                <li>Run: <code>npm run db:push -w server</code></li>
                <li>Restart: <code>npm run dev:server</code></li>
              </ol>
            </>
          ) : (
            <p className="text-on-surface-variant">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
